import {
  notifyViewStartLoading,
  PageComponentId,
} from '@wix/business-manager-api';
import { wixAxiosConfig } from '@wix/wix-axios-config';
import { ExperimentsBag } from '@wix/wix-experiments';
import axios from 'axios';
import React, { Component } from 'react';
import { IntlProvider } from 'react-intl';
import { ModuleRegistry } from 'react-module-container';
import { Router } from 'react-router-dom';
import { COMPONENT_NAME, IBMModuleParams } from './config';
import { App } from './containers/App';
import { updateDefaultsBiLogger } from './services/biLogger';
import { createHistory } from './utils/createHistory';
import { ExperimentsProvider } from './utils/hooks/useExperiments';
import { NotificatorProvider } from './utils/hooks/useNotificator';
import { VideoMakerProvider } from './utils/hooks/useVideoMaker';
import { VideoMakerTemplatesProvider } from './utils/hooks/useVideoMakerTemplates/useVideoMakerTemplates';

wixAxiosConfig(axios, {
  baseURL: '/',
});

interface IOuter extends IBMModuleParams {
  mediaToken: string;
  translations: Record<string, string>;
  experiments: ExperimentsBag;
  routeBaseName: string;
}

export class VideoMakerHomeApp extends Component<IOuter> {
  constructor(props: IOuter) {
    super(props);
    notifyViewStartLoading(COMPONENT_NAME);

    updateDefaultsBiLogger({
      msid: props.metaSiteId,
      origin: 'dashboard',
      source: 'promote-video-home',
    });
  }

  render() {
    const {
      metaSiteId,
      mediaToken,
      accountLanguage: locale,
      userId,
      translations,
      experiments,
      debug,
      liveSite,
      routeBaseName,
    } = this.props;

    const basename = `${routeBaseName}${metaSiteId}/video-maker-home`;
    const history = createHistory({ basename });

    return (
      <ExperimentsProvider experiments={experiments}>
        <IntlProvider locale={locale} messages={translations}>
          <VideoMakerProvider
            locale={locale}
            siteMediaToken={mediaToken}
            metaSiteId={metaSiteId}
            userId={userId}
          >
            <VideoMakerTemplatesProvider debug={debug} liveSite={liveSite}>
              <NotificatorProvider>
                <Router history={history}>
                  <App mediaToken={mediaToken} />
                </Router>
              </NotificatorProvider>
            </VideoMakerTemplatesProvider>
          </VideoMakerProvider>
        </IntlProvider>
      </ExperimentsProvider>
    );
  }
}

ModuleRegistry.registerComponent(
  'video-maker-home-app' as PageComponentId,
  () => VideoMakerHomeApp,
);
